import { useScrollVisible } from "./useScrollVisible";

const ACROSTIC: [string, string][] = [
  ["Z", "eit für Dich"],
  ["I", "ndividuell"],
  ["E", "nergie im Fluss"],
  ["L", "ebensqualität steigern"],
  ["B", "lockaden lösen"],
  ["A", "ngst abbauen"],
  ["L", "eichter lernen"],
  ["A", "uflösen hinderlicher Glaubenssätze"],
  ["N", "euausrichtung"],
  ["C", "hronische Schmerzen lindern"],
  ["E", "ntfaltung des Potentials"],
];

export function Vision() {
  const { ref, visible } = useScrollVisible(0.1);

  return (
    <section id="vision" className="relative py-24 md:py-32 bg-stone-900 text-sand-100 overflow-hidden">
      <div
        className="absolute inset-0 -z-10 opacity-[0.05]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 1px 1px, currentColor 1px, transparent 0)",
          backgroundSize: "32px 32px",
          color: "var(--color-sand-50)",
        }}
      />

      <div ref={ref} className="max-w-6xl mx-auto px-5 lg:px-10">
        <div className="grid md:grid-cols-[1fr_1.25fr] gap-12 md:gap-20 items-center">
          <div
            className={`transition-all duration-700 ${
              visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
            }`}
          >
            <div className="flex items-center gap-3 mb-8">
              <span className="w-8 h-px bg-terra-400" />
              <span className="text-terra-400 text-[11px] tracking-[0.35em] uppercase font-medium">
                Meine Vision
              </span>
            </div>
            <h2 className="font-display text-4xl md:text-5xl text-sand-50 leading-[1.1] tracking-tight font-semibold">
              Meine Vision
              <br />
              hinter <span className="text-sage-300">„Zielbalance"</span>.
            </h2>
            <p className="mt-8 text-sand-100/75 leading-relaxed font-light text-base max-w-sm">
              Jeder Buchstabe steht für eine Facette dessen, was ich Dir in meiner
              Praxis ermöglichen möchte.
            </p>
          </div>

          <ul
            className={`space-y-1.5 transition-all duration-700 delay-150 ${
              visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
            }`}
          >
            {ACROSTIC.map(([initial, rest], i) => (
              <li
                key={i}
                className="group flex items-baseline gap-4 py-2 border-b border-sand-100/10"
              >
                <span className="font-display text-3xl md:text-4xl text-sage-300 font-semibold w-9 shrink-0 group-hover:text-terra-400 transition-colors duration-300">
                  {initial}
                </span>
                <span className="text-lg md:text-xl text-sand-50 font-light tracking-wide">
                  {rest}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
